import axios from "@common/api/desktop/axios";
import prepareDetails from "@helpers/prepareDetails";
import { getOptionValue } from "@helpers/options";

class RevenueTermsClient {
  getProfiles = async (operatorId) => {
    const response = await axios.get(`RevenueTerms/Profiles/${operatorId}`);
    return response.data;
  };

  newProfile = async (operatorId) => {
    const response = await axios.get(`RevenueTerms/New/${operatorId}`);
    return response.data;
  };

  getProfile = async (operatorId, profileId) => {
    const response = await axios.get(
      `RevenueTerms/Profile/${operatorId},${profileId}`,
    );
    return response.data;
  };

  updateProfile = async (operatorId, id, options, complete) => {
    const details = {};

    options.forEach((option) => {
      details[option.code] = getOptionValue(option);
    });

    const response = await axios.put(`RevenueTerms/Update`, {
      operatorId,
      id,
      details: prepareDetails(details),
      complete,
    });
    return response.data;
  };
}

const client = new RevenueTermsClient();

export default client;
